<template>
  <div class="container-bg" :id="cartIds()">
    <!--card finess institution -->
    <span class="temp-type-card">{{ cardData.ss_type }}</span>
    <div :data-id="cardData.id" :data-nid="cardData.item_id" :data-ss-type="cardData.ss_type" class="card-title">
      <div class="card-wrapper-header">
        <div class="card-title-detail">
          <h2>
            <a :data-nid="cardData.item_id"
                target="_blank"
               :href="cardLink"
               @click="clickOnTitle()"
            >
              {{ cardData.tus_title }} <span class="sr-only">(nouvelle fenêtre)</span>
            </a>
          </h2>
          <p class="b-position" v-if=" hasPharmacyBloc && cardNames.length > 1">
            {{ cardNames[1] }}
          </p>
          <p class="b-position" v-else-if="cardNames">
            {{ cardNames[0] }}
          </p>
        </div>
        <p v-if="cardData.ss_field_icon_type" class="picto">
          <i :class="cardData.ss_field_icon_type" aria-hidden="true"></i>
          <span class="sr-only">{{ labelIcon }}</span>
        </p>
      </div>
    </div>
    <ServicesCardButtonModal
      v-if="cardData.services?.length"
      :open-modal-services="openModalServices"
      :services="cardData.services"
    />
    <div class="wrapper-items-btngo">
      <ul class="wrapper-items">
        <slot name="blocService"/>
        <!-- start bloc activities/ spécialités -->
        <template v-if="cardData.ss_field_information_propose_name==='ROR-COMMUN'">
        <li class="card-elm-item" v-if="hasProfessionalBloc && cardData.tm_prof_specialities$name">
          <i class="icon icon-cards_activites"><span class="sr-only">Spécialités</span></i>
          <div class="list-specialities">
            <ul>
              <li v-for="speciality in cardData.tm_prof_specialities$name " :key="speciality">{{ speciality }}</li>
            </ul>
          </div>
        </li>
        </template>
        <!-- end  bloc activities/ spécialités -->
        <!-- start bloc case pharmacie avec label highlight-->
        <template v-if="hasPharmacyBloc && cardData.labels && Object.keys(cardData.labels).length !== 0">
          <li class="card-elm-item2">
            <strong v-for="(label) in filtredLabels" :key="label" >En fonction de votre recherche : </strong>
            <a v-for="(label) in filtredLabels" :key="label"  :href="'/' + label.lien" >{{label.titre}} </a>
          </li>
        </template>
        <!-- end bloc label highlight-->
        <!-- start bloc google & link map -->
        <li class="card-elm-item" v-if="cardData.tus_field_adresse1">
          <i class="icon icon-pin" aria-hidden="true"><span class="sr-only">Adresse</span></i>
          <span>
            <a :href="mapUrl"
                class="goto-card-rwd "
                target="_blank"
                rel="noopener noreferrer"
                :aria-label="'Zoomer sur l\'adresse'  + cardData.tus_field_adresse1 + ',' + cardData.ss_field_codepostal + ',' + cardData.tm_X3b_und_field_ville" >
                {{ cardData.tus_field_adresse1 }}
            </a>

            <a href="#"
                class="goto-card"
                @click.prevent="$emit('onMapAskFlyTo')"
                :data-details="cardData.locs_field_geolocalisation$latlon"
                :aria-label="'Zoomer sur l\'adresse'  + cardData.tus_field_adresse1 + ',' + cardData.ss_field_codepostal + ',' + cardData.tm_X3b_und_field_ville"
            >{{ cardData.tus_field_adresse1 }}</a>
          </span>

        </li>
        <!-- start bloc google & link map -->

        <!-- start bloc distance -->
        <li class="card-elm-item" v-if="cardData.dist">
          <i class="icon icon-distance" aria-hidden="true"><span class="sr-only">Distance</span></i>
          <span>{{ getDistance }}</span>
        </li>
        <!-- end bloc distance -->

        <!-- start bloc hours -->
        <template v-if="showHoraire">
            <horaire-component v-if="cardData.tm_field_horaires" :horaires="cardData.tm_field_horaires" :tz="cardData.timezone"></horaire-component>
        </template>
        <!-- end bloc hours -->

        <slot name="blocProfessional"/>
        <!-- start bloc phone -->
        <template v-if="!$slots.blocProfessional">
          <PhoneIcon :phone="phone" v-if="phone"/>
        </template>
        <!-- end bloc phone -->
        <!-- start bloc RDV -->
        <template
          v-if=" hasAppointmentBloc &&
            cardData.tm_field_site_internet$url &&
            cardData.tm_field_site_internet$title[0].toLowerCase().trim() ===
              'prendre rendez-vous en ligne' &&
            cardData.tm_field_site_internet$url[0] !== ''
          "
        >
          <li class="visible-small card-elm-item">
            <i class="icon icon-calendar" aria-hidden="true"></i>
            <a :href="cardData.tm_field_site_internet$url[0]"
              class="to-uppercase"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="cardData.tm_field_site_internet$title[0] + ' (nouvelle fenêtre)'">
                Prendre rendez-vous en ligne
                <span class="external-link-icon" aria-hidden="true"></span>
            </a>
          </li>
          <li class="hidden-small">
            <a :href="cardData.tm_field_site_internet$url[0]"
              class="btn btn-style-01 full-blue-light website-link external-link mt-10"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="cardData.tm_field_site_internet$title[0] + ' (nouvelle fenêtre)'"
            >
              Prendre rendez-vous en ligne
              <span class="external-link-icon" aria-hidden="true"></span>
            </a>
          </li>
        </template>
        <!-- end bloc RDV -->
      </ul>
      <!-- start button y aller -->
      <div class="btngo">
        <a
          v-if="cardData.ss_field_site_internet"
          class="link-external-action make-appointment"
          :href="cardData.ss_field_site_internet"
          target="_blank"
          :aria-label="(cardData.ss_field_site_internet_title ? cardData.ss_field_site_internet_title : 'Site internet') + '(nouvelle fenêtre)'"
        >
          <span>{{ cardData.ss_field_site_internet_title ? cardData.ss_field_site_internet_title : 'SITE INTERNET' }}</span>
          <i class="icon-external-link" aria-hidden="true"></i>
        </a>
        <a
          class="link-external-action go-there tip-icon only-desctop"
          :href="mapUrl"
          key="mapUrl"
          target="_blank" rel="noopener noreferrer"
          :aria-label="'Aller à l\'adresse'  + cardData.tus_field_adresse1 + ',' + cardData.ss_field_codepostal + ',' + cardData.tm_X3b_und_field_ville + '(nouvelle fenêtre)'"
        >
          <span>Y aller</span>
          <i class="icon icon-distance" aria-hidden="true"></i>
        </a>
      </div>
      <!-- end button y aller -->
    </div>

    <!-- start label complementaire covid depistage etc -->
    <template v-if="cardData.sm_field_custom_label_permanent_label" >
      <div class="labels">
        <ul class="additional-label-wrapper">
          <li class="additional-label" v-for="label in cardData.sm_field_custom_label_permanent_label"
            :key="label"
          >
            {{ label }}
          </li>
        </ul>
      </div>
    </template>
    <!-- end label complementaire covid depistage etc -->

  </div>
</template>

<script>
import {
  computed, inject, ref,
} from 'vue';
import { setOriginSearch } from '@/helpers';
import FavouriteCardHook from '@/hooks/favouriteCard.hook';
import useOnRowIsDisabled from '@/composables/useOnRowIsDisabled';

import HoraireComponent from '@/components/legacy/searchFind/HoraireComponent.vue';
import PhoneIcon from '@/components/legacy/searchFind/cardType/PhoneIcon.component.vue';
import ServicesCardButtonModal from '@/components/searchFind/ServicesCardButtonModal.component.vue';

export default {
  name: 'CardStandardComponent',
  components: {
    'horaire-component': HoraireComponent,
    PhoneIcon,
    ServicesCardButtonModal,
  },
  props: {
    cardData: Object,
    isConnected: { type: Boolean, default: false },
    listResFav: { type: Array, default: () => ([]) },
    mapUrl: { type: String, default: '' },
    dataTrack: { type: String, default: '' },
    labelIcon: { type: String, default: '' },
    hasAppointmentBloc: { type: Boolean, default: false },
    hasHealthInstitutionBloc: { type: Boolean, default: false },
    hasProfessionalBloc: { type: Boolean, default: false },
    hasPharmacyBloc: { type: Boolean, default: false },
    cardLink: { type: String, default: () => '' },
    cardNames: { type: Array, default: () => ([]) },
    context: { type: String, default: '' },
    tcModeType: { type: String, default: '' },
    isMobile: { type: Boolean, default: false },
  },
  emits: ['onMapAskFlyTo'],
  setup(props, { emit }) {
    const {
      favorisClass, favorisClick, favorisIsIn, isFavBtnClicked, isActiveCard, favorisStarClass,
    } = FavouriteCardHook(props, emit);
    const { onRowIsDisabled } = useOnRowIsDisabled();
    const phone = ref(props.cardData.tm_X3b_und_field_phone_number ? props.cardData.tm_X3b_und_field_phone_number?.[0] : props.cardData.tm_field_telephone_fixe?.[0]);
    const longLat = ref(props.cardData.locs_field_geolocalisation$latlon);

    const openModalServices = inject('openModalServices');

    const getDistance = computed(() => {
      if (!props.cardData.dist) return '';
      return Math.ceil(props.cardData.dist) > 1 ? `${Math.ceil(props.cardData.dist)} km` : `${Math.ceil(props.cardData.dist * 1000)} m`;
    });
    const showHoraire = computed(() => {
      if (!props.cardData.ds_field_eg_date_ouverture && !props.cardData.ds_field_eg_date_fermeture) {
        return true;
      }
      let res = true;
      const tmpNowDate = (new Date()).toLocaleDateString('fr-FR', { timeZone: props.cardData.timezone ? props.cardData.timezone : 'Europe/Paris' }).split('/');
      if (tmpNowDate.length !== 3) {
        console.warn('Date API not working as expected.');
        return true;
      }
      const nowDate = `${tmpNowDate[2]}${tmpNowDate[1]}${tmpNowDate[0]}`;
      if (props.cardData.ds_field_eg_date_ouverture) {
        const startDateObj = new Date(props.cardData.ds_field_eg_date_ouverture);
        const startDate = `${startDateObj.getFullYear()}${(startDateObj.getMonth() + 1) < 10 ? '0' : ''}${startDateObj.getMonth() + 1}${startDateObj.getDate() < 10 ? '0' : ''}${startDateObj.getDate()}`;
        res = parseInt(startDate, 10) <= parseInt(nowDate, 10);
      }
      if (res && props.cardData.ds_field_eg_date_fermeture) {
        const endDateObj = new Date(props.cardData.ds_field_eg_date_fermeture);
        const endDate = `${endDateObj.getFullYear()}${(endDateObj.getMonth() + 1) < 10 ? '0' : ''}${endDateObj.getMonth() + 1}${endDateObj.getDate() < 10 ? '0' : ''}${endDateObj.getDate()}`;
        res = parseInt(nowDate, 10) <= parseInt(endDate, 10);
      }
      return res;
    });

    function cartIds() {
      const cartId = props.cardData.item_id;
      return `card-node-${cartId}`;
    }

    function clickOnTitle() {
      setOriginSearch();
    }

    return {
      cartIds,
      clickOnTitle,
      favorisClass,
      favorisClick,
      favorisIsIn,
      favorisStarClass,
      isActiveCard,
      isFavBtnClicked,
      getDistance,
      longLat,
      onRowIsDisabled,
      openModalServices,
      phone,
      setOriginSearch,
      showHoraire,
    };
  },
};
</script>

<style lang="scss">
  .card {
    margin: 0;
    position: relative;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 26px 20px 30px 26px;
    border: 2px solid white;
    background-color: white;
  }
</style>
